import { usePreviewRunServicesQuery } from "@/api/previewInsights";
import { callsForOrdinal, turnOrdinal } from "@/lib/labServices";
import type { LabRunData, LabTurn } from "@/lib/labModel";
import { ErrorState, LoadingState } from "@/ui/states";

import { LabServicesPanel } from "../LabServicesPanel";

import { Section } from "./LabTurnSummary";

/** This turn's service calls, mapped by the turn's ordinal among the run's turns. */
export function LabTurnServicesTab({
  projectId,
  run,
  turn,
}: {
  projectId: string;
  run: LabRunData;
  turn: LabTurn;
}) {
  const query = usePreviewRunServicesQuery(projectId, run.previewRunRef, {
    live: run.live,
  });
  const ordinal = turnOrdinal(run.lab.turns, turn.turnNumber);
  return (
    <Section title="Services">
      {query.isPending ? (
        <LoadingState label="Loading service calls" rows={2} />
      ) : query.isError ? (
        <ErrorState
          title="Service calls could not be read"
          onRetry={() => void query.refetch()}
        />
      ) : (
        <LabServicesPanel calls={callsForOrdinal(query.data, ordinal)} />
      )}
    </Section>
  );
}
